import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useAppStore = defineStore('app', () => {
  // State
  const isLoading = ref(false)
  const isVideoReady = ref(false)
  const sidebarCollapsed = ref(false)
  const currentUser = ref<any>(null)
  
  // Getters
  const isAuthenticated = computed(() => !!currentUser.value)
  const userName = computed(() => currentUser.value?.name || '')
  
  // Actions
  const setLoading = (loading: boolean) => {
    isLoading.value = loading
  }

  const setVideoReady = (ready: boolean) => {
    isVideoReady.value = ready
  }
  
  const toggleSidebar = () => {
    sidebarCollapsed.value = !sidebarCollapsed.value
  }
  
  const setSidebarCollapsed = (collapsed: boolean) => {
    sidebarCollapsed.value = collapsed
  }
  
  const setCurrentUser = (user: any) => {
    currentUser.value = user
  }
  
  const logout = () => {
    currentUser.value = null
    // Clear any stored tokens or user data
    localStorage.removeItem('auth-token')
  }
  
  return {
    // State
    isLoading,
    isVideoReady,
    sidebarCollapsed,
    currentUser,
    
    // Getters
    isAuthenticated,
    userName,
    
    // Actions
    setLoading,
    setVideoReady,
    toggleSidebar,
    setSidebarCollapsed,
    setCurrentUser,
    logout
  }
})